export const COOKIES_KEY_SELECTED_OFFER_ID = 'selectedOfferId';
export const COOKIES_KEY_PLAN_TAG = 'planTag';
export const COOKIE_KEY_IS_EXPERIMENT_PLAN_TAG = 'isExperimentPlanTag';
